import type { PasskeyEnrollmentMembers } from '@auth0/auth0-acul-react/types';
import { usePasskeyEnrollment } from '@auth0/auth0-acul-react/passkey-enrollment';

import { executeSafely } from '@/utils/helpers/executeSafely';

/**
 * Handles the passkey enrollment process.
 */
export const usePasskeyEnrollmentManager = () => {
  const passkeyEnrollmentInstance: PasskeyEnrollmentMembers =
    usePasskeyEnrollment();

  const continuePasskeyEnrollment = async (): Promise<void> => {
    executeSafely(`Continue Passkey Enrollment`, () =>
      passkeyEnrollmentInstance.continuePasskeyEnrollment(),
    );
  };

  const abortPasskeyEnrollment = async (): Promise<void> => {
    executeSafely(`Continue without Passkey Enrollment:`, () =>
      passkeyEnrollmentInstance.abortPasskeyEnrollment(),
    );
  };

  const shouldAbortEnrollment =
    window.location.href.includes('signup/passkeys');

  return {
    passkeyEnrollmentInstance,
    continuePasskeyEnrollment,
    abortPasskeyEnrollment,
    shouldAbortEnrollment,
  };
};
